import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { LettersApi, type CreateLettersRequest } from '@shared/api';

interface UseCreateLetterStore {
  data: string | null;
  loading: boolean;
  error: string | null;
  success: boolean;
  createLetter: (request: CreateLettersRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCreateLetterStore = create<UseCreateLetterStore>((set) => ({
  data: null,
  loading: false,
  error: null,
  success: false,

  createLetter: async (request: CreateLettersRequest, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      const result = await LettersApi.createLetter(request, signal);
      set({ loading: false, data: result ?? null, success: true });
    } catch (error) {
      set({ loading: false, success: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => set({ loading: false, data: null, success: false, error: null }),
}));
